import { FormularioDeLogin } from './FormularioDeLogin';

/**
 * Lo que se ve cuando el backend rechaza la credencial **con la persona
 * trabajando**.
 *
 * # POR QUÉ NO ES UNA REDIRECCIÓN AL LOGIN
 *
 * Porque mandar al login desmonta la pantalla, y con ella el formulario a medio
 * llenar. En este sistema eso puede ser una factura entera cargada a mano: los
 * ítems, el receptor, las alícuotas. Perderla porque un admin desactivó a
 * alguien —o porque pasaron dos horas— es exactamente el tipo de detalle que
 * hace que la gente termine facturando por otro lado.
 *
 * Así que la pantalla de atrás **se queda montada** y esto se superpone. Al
 * reingresar, el estado sigue donde estaba y la persona vuelve a apretar
 * "Emitir".
 *
 * Ojo con lo que esto NO es: mientras el diálogo está arriba no hay token, así
 * que cualquier pedido que la pantalla de atrás intente sale sin credencial y
 * el backend lo rechaza. Eso está bien —es deny-by-default y hace su trabajo—;
 * lo que se preserva es lo que la persona escribió, no el acceso.
 */
export function DialogoDeReingreso({ email }: { email: string }) {
  return (
    <div className="fondo-modal">
      <div className="modal" role="dialog" aria-modal="true" aria-labelledby="titulo-reingreso">
        <h2 id="titulo-reingreso">Tu sesión terminó</h2>
        <p>
          El servicio dejó de aceptar tu credencial. Puede ser que haya vencido, o que un
          administrador haya cambiado tu cuenta. Volvé a entrar: lo que estabas cargando sigue
          donde lo dejaste.
        </p>
        <FormularioDeLogin emailInicial={email} textoDelBoton="Volver a entrar" />
      </div>
    </div>
  );
}
